import { makeStyles } from "@material-ui/core";

const progressStepsStyle = makeStyles((theme) => ({
  progressContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    maxWidth: "600px",
    marginBottom: "10px",
  },
  progressStep: {
    width: "14px",
    height: "14px",
    borderRadius: "50%",
    backgroundColor: "#4a4a4a",
    margin: "0 8px",
  },
  activeStep: {
    backgroundColor: "#f06ec4",
  },
  progressLine: {
    width: "30px",
    height: "2px",
    backgroundColor: "#4a4a4a",
  },
}));

export default progressStepsStyle;
